<template>
    <core-grouped-drop-down
        :items="items"
        :selection.sync="selected"
        noneLabel="- none -"
        noLabel
        valueAttribute="itemId"
    ></core-grouped-drop-down>
</template>

<script>
export default {
  props: {
    traveler: {
      type: Object,
      required: true
    },
    selectedValue: {
      type: String | Number,
      required: true
    },
    coupes: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selected: this.selectedValue,
      items: this.coupes
    }
  },
  watch: {
    selected: {
      handler (val) {
        this.$emit('selected', val, this.traveler)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/details/travelers/Coupe.vue